import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "etl-prints-home",
        path: "/etl-prints",
        component: () => import("./componentsOld/EtlPrintsTileContainer.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}] }
    },
    {
        name: "etl-imp-exp-home",
        path: "/etl-imp-exp",
        component: () => import("./componentsOld/EtlImportExportTileContainer.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}] }
    },
    {
        name: "etl-imp-exp-bo",
        path: "/etl-imp-exp-bo",
        component: () => import("./componentsOld/EtlImportExportBoTileContainer.vue"),
        meta: {}
    },
    {
        name: "etl-imp-exp-enterprise",
        path: "/etl-imp-exp-enterprise",
        component: () => import("./componentsOld/EtlImportExportEnterpriseTileContainer.vue"),
        meta: {}
    },

    {
        name: "etl-prints-home-v2",
        path: "/etl-prints-v2",
        component: () => import("./components/tiles/ImportExportListTile.vue"),
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item", props: { isRequired: true } }] }
    },
    {
        name: "etl-imp-exp-home-v2",
        path: "/etl-imp-exp-v2",
        component: () => import("./components/tiles/ImportExportListTile.vue"),
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item", props: { isRequired: true } }] }
    },
    {
        name: "etl-imp-exp-bo-v2",
        path: "/etl-imp-exp-bo-v2",
        component: () => import("./components/tiles/ImportExportListTile.vue"),
        meta: {}
    },
    {
        name: "etl-imp-exp-enterprise-v2",
        path: "/etl-imp-exp-enterprise-v2",
        component: () => import("./components/tiles/ImportExportListTile.vue"),
        meta: {}
    }
];

export default routes;
